export default __webpack_public_path__ + "static/media/opened.7fc9188d.svg";